import Axios from "./axios";

const resource = "faqs";
const resellerResource = "reseller-faqs";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	resellerGet(params) {
		return Axios.get(`${resellerResource}`, params);
	}
}